export default "__VITE_ASSET__BQyBmPKE__"